export enum WizardPhase {
    AccountType = 0,
    Authorization = 1,
    BuildingInformation = 2,
    LayoutInformation = 3,
    HeatLossCalculation = 3,
}

export enum WizardName {
    otz = 'otz-wizard',
    heatPump = 'heat-pump-wizard',
}

export enum WizardStep {
    Login = 1,
    BuildingBasicInfo,
    ApprovalDate,
    KnowHeatLoss,
    OldHeatSource,
    ElectricInsulation,
    GasInsulation,
    YearOfBuilding,
    HavePENB,
    TypeOfPENB,
    MeasuredHeatLossPENB,
    BuildingVolumeVPENB,
    AvgHeatTransferOfBuildingPENB,
    TotalAreaOfEvaluatedBuildingCoverPENB,
    EnergyLossPENB,
    BuildingPhase,
    RoughConstructionEndDate,
    HouseTotalArea,
    HeatLoss,
    HouseFloorPlanShape,
    HouseFloorPlanShapeDetail,
    RoofType,
    FloorCount,
    GarageBasementAtticArea,
    RoomDispositions,
    HouseGlazing,
    WallInsulation,
    WallInsulationThickness,
    FloorInsulation,
    FloorInsulationThickness,
    RoofInsulation,
    RoofInsulationThickness,
    NumberOfFloors,
    HouseLayout,
    NumberOfBathrooms,
    BuildingPermitDate,
    BuildingType,
    BuildingProcess,
    Attic,
    AtticHeated,
    Garage,
    GaragePartOfBuilding,
    Recuperation,
    RoomFloorAreas,
    RoomsWithRecuperation,
    Photovoltaics,
    BuildingInsulations,
    Preferences,
    Result,
    DocumentationUpload,
    RoomSizes,
    RoomRecuperation,
    Final,
}
